import { css, html } from "../helpers/webComponents";

const style: string = css`
    .inputfield {
        background: var(--input-bg, #D2A679);
        padding: 15px;
        border: 3px solid #4e4e4e;
        border-radius: 5px;
        box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: "Onesize";
        font-size: 18px;
        margin-top: 200px;
        position: relative;
        width: 320px; /* Adjust width to fit content */
        text-align: center; /* This should center the text, but we need to ensure it works with placeholder */

    }
        
    /* Input Container */
    .input-container {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* Floating Label */
    .input-label {
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: rgba(255, 255, 255, 0.7);
        transition: all 0.3s ease-in-out;
        pointer-events: none;
        font-family: "Onesize";
        background: transparent;
    }

    /* Input Field */
    input {
        background: var(--input-bg, #D2A679);
        color: white;
        border: 2px solid #780606;
        padding: 12px;
        font-size: 18px;
        font-family: "Onesize";
        width: 100%;
        text-align: center;
        outline: none;
        border-radius: 5px;
    }

    /* Move Label When Focused or When There's Text */
    input:focus + .input-label,
    input:not(:placeholder-shown) + .input-label {
        top: 0px;
        left: 12px;
        font-size: 14px;
        color: white;
        background: var(--input-bg, #D2A679);
        padding: 2px 5px;
        text-align: center;
    }

    /* Submit Button */
    #submitButton {
        background: var(--button-bg, #8B5A2B);
        color: var(--button-color, #F8E4C9);
        border: 2px solid #5C4033;
        padding: 10px 15px;
        font-weight: bold;
        text-transform: uppercase;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        cursor: pointer;
        margin-top: 15px;
        transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
        font-family: "Onesize";
        width: 100%;
    }

    /* Submit Button Hover Effect */
    #submitButton:hover {
        background: #000000;
        transform: scale(1.05);
    }

    /* Exit Button */
    #exit-puzzle-button {
        background: var(--extra-bg, #4A2F1B);
        color: var(--extra-text, #E3C59D);
        font-size: 18px;
        padding: 10px 15px;
        border: 3px solid #4e4e4e;
        border-radius: 5px;
        text-transform: uppercase;
        font-weight: bold;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        cursor: pointer;
        margin-top: 10px;
        transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
        font-family: "Onesize";
        width: 100%;
    }

    /* Exit Button Hover Effect */
    #exit-puzzle-button:hover {
        background: #000000;
        transform: scale(1.05);
    }
`;

export class InputfieldComponent extends HTMLElement {
    private _placeholder: string | undefined;
    private _buttonText: string | undefined;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this._placeholder = this.attributes.getNamedItem("placeholder")?.value || "";
        this._buttonText = this.attributes.getNamedItem("button-text")?.value || "Submit";

        this.render();
    }

    public render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const element: HTMLElement = html`
         <div class="inputfield">
        <div class="input-container">
            <input type="text" id="inputField" placeholder=" " />
            <label class="input-label">${this._placeholder!}</label>
        </div>
        <button id="submitButton">${this._buttonText}</button>
        <div data-type="extra-content"></div>
        <style>${style}</style>
    </div>
`;

        element.querySelector("button")?.addEventListener("click", e => {
            e.preventDefault();

            this.dispatchEvent(new CustomEvent("data-submitted", {
                detail: element.querySelector("input")?.value,
            }));
        });

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.appendChild(element);
    }
}
